<template>
  <div v-if="menus" :class="{center}" class="modal-menu">
    <div class="modal-menu__item"
         :class="{'modal-menu__item--selected': (index + 1) === selected}"
         v-for="(m, index) in menus" v-show="m.active">
      <a class="text-muted d-flex align-items-start" href="javascript:" @click="change(index + 1)">
        {{m.nome}} <span class="badge badge-warning badge-new ml-1" v-if="m.new">Novo</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalMenu',
  props: ['menus','selected','center'],
  methods: {
    change(index) {
      this.$emit('changeMenu', index)
    }
  }
}
</script>
<style scoped>
.modal-menu {
  border-bottom: 1px solid #ccc;
  margin-bottom: 1rem;
}
.modal-menu.center {
  display: flex;
  align-items: stretch;
}
.modal-menu.center .modal-menu__item {
  flex: 1 1 0;
  min-width: 0;
  margin-right: 0;
  margin-bottom: 0;
}
.modal-menu.center .modal-menu__item a {
  justify-content: center;
  height: 100%;
  padding: 10px 8px 12px;
}
.modal-menu__item {
  position: relative;
  display: inline-block;
  margin-right: 26px;
  padding: 0;
  text-align: center;
  font-size: 16px;
  margin-bottom: 12px;
}
.modal-menu__item a:hover, .modal-menu__item a:visited, .modal-menu__item a:focus {
  text-decoration: none;
}
.modal-menu__item--selected {
  border-bottom: 2px solid;
  border-color: var(--primary);
  font-weight: bold;
}
.modal-menu__item--selected a {
  color: var(--primary)!important;
}
.badge-new {
  font-size: 60%!important;
  position: absolute;
  right: -22px;
  top: -9px;
}
</style>
